import { render, staticRenderFns } from "./AssignmentProgressIndicator.vue?vue&type=template&id=1078f75e&scoped=true&"
import script from "./AssignmentProgressIndicator.vue?vue&type=script&lang=js&"
export * from "./AssignmentProgressIndicator.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentProgressIndicator.vue?vue&type=style&index=0&id=1078f75e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1078f75e",
  null
  
)

export default component.exports